<script>
    export let state;
</script>

<span class="{state}">
    {state=="active"?"Aktiv"
    :state=="archived"?"Archiviert"
    :"Status unbekannt"}
</span>

<style>
    span {
        font-size: 0.8rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        display: inline-block;
        background-color: #E0D8D2;
        color: rgb(117, 107, 100);
    }

    .active{        
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
    }

    .archived {        
        background-color: rgb(210, 210, 210);
        color: rgb(30, 30, 30);
    }
</style>